import progress from '../../utils/progress';

let formIsBeingSubmitted = false;

/**
 *  Initializes the form submit event
 */
const initSubmitEvent = () => {
    const unsubscribeForm = document.querySelector('#availability-reminder-unsubscribe-form');
    if (unsubscribeForm === null) {
        return;
    }
    unsubscribeForm.addEventListener('submit', e => {
        e.preventDefault();
        if (formIsBeingSubmitted) {
            return;
        }

        formIsBeingSubmitted = true;
        progress.show(unsubscribeForm);
        const formData = $(unsubscribeForm).serialize();
        $.ajax({
            dataType: 'json',
            method: 'POST',
            url: unsubscribeForm.action,
            data: formData,
            /**
             * @param response
             */
            success: response => {
                const container = document
                    .querySelector('#primary')
                    .querySelector('.availability-reminder-unsubscribe-section');
                container.innerHTML = response.message;
                if (response.content) {
                    container.innerHTML += response.content;
                }
                formIsBeingSubmitted = false;
                progress.hide();
            },
            /**
             *
             */
            error: () => {
                formIsBeingSubmitted = false;
                progress.hide();
            }
        });
    });
};

/* eslint-disable import/prefer-default-export */
/**
 * Initializes  availability reminder opt-out page.
 */
export const init = () => {
    initSubmitEvent();
};
